import {systemConfirm} from '@web/actions/application'
import {isLocalProfile} from '@web/core/config'
import {createStore as configureStore} from '@web/helpers/redux'
import {browserEventEmitter} from '@web/middlewares/browserEventEmitter'

import createRootReducer from '../slices'

import {
    sessionSync,
    orderInterruptedMiddleware,
    sentryMiddleware,
    errorLoggerMiddleware,
    loggerMiddleware,
    maintenanceHandlerMiddleware,
} from './middlewares'
import alertProcessMiddleware from './middlewares/alertProcessMiddleware'
import auth from './middlewares/auth'
import uiEventLogger, {uiEventActions} from './middlewares/uiEventLoggerMiddleware'
import OrderCheckoutSentryEnhancer from './sentryEnhancer'

import type {RootState} from '../interfaces'

export {browserHistory} from '@web/helpers/redux'

/**
 * todo preloadedState를 넣을 수 있는 createStore 테스트 전용. 정리 필요
 * @param preloadedState
 * @returns
 */
export const createStore = (preloadedState?: RootState) => {
    return configureStore<RootState>({
        rootReducerCreator: createRootReducer,
        preloadedState,
        middlewares: [
            auth,
            maintenanceHandlerMiddleware,
            loggerMiddleware,
            sessionSync,
            orderInterruptedMiddleware,
            alertProcessMiddleware,
            sentryMiddleware,
            uiEventLogger,
            browserEventEmitter,
            errorLoggerMiddleware,
        ],
        defaultMiddlewareOptions: {
            serializableCheck: {
                ignoredActions: [systemConfirm.type, ...uiEventActions],
            },
        },
        sentryEnhancerOptions: OrderCheckoutSentryEnhancer,
    })
}

const store = createStore()

if (isLocalProfile) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ;(window as any).store = store
}

export default store

if (isLocalProfile && module.hot) {
    module.hot.accept('../slices', () => store.replaceReducer(createRootReducer()))
}
